<div class="wrapper" [ngClass]="{ 'left-sidebar-not-visible': !leftSidebarVisible() }">
    <div class="left-side">
        <div class="logo"></div>
    </div>

    <div class="right-side">
        <hamburger-menu></hamburger-menu>
        <ev-message-center
            [messages]="messageCenterStore.messages()"
            [lastRead]="messageCenterStore.lastRead()"
            (onToggle)="updateReadMessages($event)"
        ></ev-message-center>
        <user-info-dialog></user-info-dialog>
    </div>
</div>
